import React, { useMemo, useState } from "react";
import ClienteSchedaOperativa from "./ClienteSchedaOperativa";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSearch,
  FaKey,
  FaMapMarkedAlt,
  FaFolderOpen,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";

const Clienti = ({
  clienti,
  onAddCliente,
  onEditCliente,
  onDeleteCliente,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [schedaClienteId, setSchedaClienteId] = useState(null);
  const [azioniClienteId, setAzioniClienteId] = useState(null);

  const normalizza = (value) =>
    String(value || "").trim().toLocaleLowerCase("it");

  const filteredClienti = useMemo(() => {
    const query = normalizza(searchQuery);
    const elenco = Array.isArray(clienti) ? clienti : [];

    if (!query) return elenco;

    return elenco.filter((cliente) =>
      [
        cliente.nome,
        cliente.indirizzo,
        cliente.telefono,
        cliente.telefono_secondario,
        cliente.email,
        cliente.codice_fiscale,
        cliente.referente,
      ]
        .map(normalizza)
        .join(" ")
        .includes(query)
    );
  }, [clienti, searchQuery]);

  const abilitaPortaleCliente = async (cliente) => {
    const clienteId = Number(cliente?.id);
    const email = String(cliente?.email || "").trim();

    if (!clienteId) {
      window.alert("Cliente non valido.");
      return;
    }

    if (!email) {
      window.alert("Inserisci prima una email nell'anagrafica del cliente.");
      return;
    }

    const password = window.prompt(
      `Imposta la password iniziale per il portale di ${
        cliente.nome || email
      }.\nMinimo 8 caratteri:`
    );

    if (!password) return;

    if (password.length < 8) {
      window.alert("La password deve contenere almeno 8 caratteri.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/api/portal-admin/clienti/${clienteId}/accesso`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ password }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data.message || "Impossibile creare l'accesso portale."
        );
      }

      window.alert(
        `Accesso portale attivato.\n\nURL: https://interventi.synology.me/portale\nEmail: ${data.email}\n\nComunica al cliente la password appena impostata.`
      );
    } catch (error) {
      window.alert(error.message || "Errore attivazione portale.");
    }
  };

  const gestisciSitiCliente = async (cliente) => {
    const clienteId = Number(cliente?.id);

    if (!clienteId) {
      window.alert("Cliente non valido.");
      return;
    }

    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/portal-admin/clienti/${clienteId}/siti`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const siti = await response.json().catch(() => []);

      if (!response.ok) {
        throw new Error(siti.message || "Impossibile caricare i siti.");
      }

      const elenco =
        Array.isArray(siti) && siti.length
          ? siti
              .map(
                (s, index) =>
                  `${index + 1}. ${s.nome} - ${s.indirizzo}${
                    s.attivo ? "" : " [disattivato]"
                  }`
              )
              .join("\n")
          : "Nessun sito configurato.";

      const nome = window.prompt(
        `Siti / impianti di ${
          cliente.nome || "cliente"
        }:\n\n${elenco}\n\nPer aggiungere un nuovo sito inserisci il nome.\nPremi Annulla per chiudere.`,
        siti.length ? "" : "Sede principale"
      );

      if (nome === null || !String(nome).trim()) return;

      const indirizzo = window.prompt(
        "Indirizzo del sito / impianto:",
        cliente.indirizzo || ""
      );

      if (indirizzo === null || !String(indirizzo).trim()) return;

      const tipoImpianto = window.prompt(
        "Tipo impianto (facoltativo):",
        cliente.tipo_impianto || ""
      );

      const createResponse = await fetch(
        `${API_BASE_URL}/api/portal-admin/clienti/${clienteId}/siti`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            nome: String(nome).trim(),
            indirizzo: String(indirizzo).trim(),
            tipoImpianto:
              tipoImpianto === null ? "" : String(tipoImpianto).trim(),
          }),
        }
      );

      const created = await createResponse.json().catch(() => ({}));

      if (!createResponse.ok) {
        throw new Error(created.message || "Impossibile creare il sito.");
      }

      window.alert(`Sito creato:\n${created.nome}\n${created.indirizzo}`);
    } catch (error) {
      window.alert(error.message || "Errore gestione siti.");
    }
  };

  return (
    <div className="tabella-interventi-container" style={{ padding: "24px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "16px",
          flexWrap: "wrap",
          marginBottom: "18px",
        }}
      >
        <div>
          <h3 className="interventi-title" style={{ marginBottom: "4px" }}>
            Clienti
          </h3>
          <div style={{ color: "#667085", fontSize: "14px" }}>
            {filteredClienti.length} clienti visualizzati
          </div>
        </div>

        <button className="add-intervento-button" onClick={onAddCliente}>
          <FaPlus /> Nuovo cliente
        </button>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          background: "#fff",
          border: "1px solid #dfe5eb",
          borderRadius: "12px",
          padding: "10px 14px",
          marginBottom: "16px",
        }}
      >
        <FaSearch style={{ color: "#667085", flex: "0 0 auto" }} />
        <input
          type="text"
          placeholder="Cerca per nome, indirizzo, telefono, email, referente o CF/P.IVA..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            border: 0,
            outline: 0,
            width: "100%",
            fontSize: "15px",
            background: "transparent",
          }}
        />
      </div>

      {filteredClienti.length === 0 ? (
        <div
          style={{
            padding: "34px",
            textAlign: "center",
            background: "#fff",
            border: "1px solid #dfe5eb",
            borderRadius: "14px",
            color: "#667085",
          }}
        >
          Nessun cliente trovato.
        </div>
      ) : (
        <div style={{ display: "grid", gap: "10px" }}>
          {filteredClienti.map((cliente) => (
            <div
              key={cliente.id}
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(0, 1fr) auto",
                gap: "16px",
                alignItems: "center",
                padding: "13px 16px",
                background: "#fff",
                border: "1px solid #dfe5eb",
                borderRadius: "13px",
                boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: 800,
                    color: "var(--verde-scuro)",
                    overflowWrap: "anywhere",
                  }}
                >
                  {cliente.nome || "Senza nome"}
                </div>

                {cliente.referente && (
                  <div
                    style={{
                      marginTop: "2px",
                      color: "#667085",
                      fontSize: "13px",
                    }}
                  >
                    Referente: {cliente.referente}
                  </div>
                )}

                <div
                  style={{
                    marginTop: "6px",
                    display: "flex",
                    gap: "13px",
                    flexWrap: "wrap",
                    color: "#475467",
                    fontSize: "13px",
                  }}
                >
                  {cliente.indirizzo && (
                    <span style={{ overflowWrap: "anywhere" }}>
                      {cliente.indirizzo}
                    </span>
                  )}

                  {cliente.telefono && (
                    <span>
                      <FaPhoneAlt style={{ marginRight: "5px" }} />
                      {cliente.telefono}
                    </span>
                  )}

                  {cliente.email && (
                    <span style={{ overflowWrap: "anywhere" }}>
                      <FaEnvelope style={{ marginRight: "5px" }} />
                      {cliente.email}
                    </span>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "7px",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  onClick={() => setSchedaClienteId(cliente.id)}
                  className="btn"
                  style={{
                    fontWeight: 800,
                    padding: "8px 12px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <FaFolderOpen style={{ marginRight: "6px" }} />
                  Apri scheda
                </button>

                <button
                  type="button"
                  onClick={() => onEditCliente(cliente)}
                  className="edit-btn"
                  title="Modifica anagrafica"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "8px 10px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <FaEdit />
                  <span>Modifica</span>
                </button>

                <button
                  type="button"
                  onClick={() => gestisciSitiCliente(cliente)}
                  className="btn"
                  title="Siti / impianti"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "8px 10px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <FaMapMarkedAlt />
                  <span>Siti</span>
                </button>

                <button
                  type="button"
                  onClick={() => abilitaPortaleCliente(cliente)}
                  className="btn"
                  title="Portale cliente"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "8px 10px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <FaKey />
                  <span>Portale</span>
                </button>

                <div style={{ position: "relative" }}>
                  <button
                    type="button"
                    onClick={() =>
                      setAzioniClienteId((prev) =>
                        Number(prev) === Number(cliente.id)
                          ? null
                          : cliente.id
                      )
                    }
                    className="btn"
                    title="Altre azioni"
                    aria-label="Altre azioni"
                    style={{
                      minWidth: "38px",
                      padding: "8px 10px",
                      fontWeight: 900,
                      fontSize: "18px",
                      lineHeight: 1,
                    }}
                  >
                    ⋯
                  </button>

                  {Number(azioniClienteId) === Number(cliente.id) && (
                    <div
                      style={{
                        position: "absolute",
                        right: 0,
                        top: "calc(100% + 6px)",
                        zIndex: 50,
                        minWidth: "170px",
                        padding: "6px",
                        borderRadius: "10px",
                        border: "1px solid #dfe5eb",
                        background: "#fff",
                        boxShadow: "0 12px 30px rgba(15,23,42,0.15)",
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          setAzioniClienteId(null);
                          onDeleteCliente(cliente.id);
                        }}
                        className="delete-btn"
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          justifyContent: "flex-start",
                          padding: "9px 10px",
                        }}
                      >
                        <FaTrash />
                        Cancella cliente
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {schedaClienteId && (
        <ClienteSchedaOperativa
          clienteId={schedaClienteId}
          onClose={() => setSchedaClienteId(null)}
        />
      )}
    </div>
  );
};

export default Clienti;
